import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { MaterialDownloadUrlResponse } from "../../materials/contracts/MaterialDownloadUrlResponse";
import portalAxios from "../portalAxios";

/**
 * An inline URL (valid 60 minutes) for opening a PDF, image or audio file in the page. Not kept
 * in the store: every Open fetches a fresh one, and viewing does not count as a download.
 */
export const fetchPortalMaterialViewUrl = createAsyncThunk<
  MaterialDownloadUrlResponse,
  { memberId: string; materialId: string },
  { rejectValue: ApiErrorResponse }
>("portal/fetchMaterialViewUrl", async ({ memberId, materialId }, { rejectWithValue }) => {
  try {
    const response = await portalAxios.get<MaterialDownloadUrlResponse>(
      `/portal/members/${memberId}/materials/${materialId}/view-url`,
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});
